import { api } from "../api";
import axios from "axios";


export const getRaces = async () => {
    const res = await axios.get(api+'races/' , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data' ,
            Accept: "application/json",
}});
    return res.data;
}
export const getRacesE = async () => {
    const res = await axios.get(api+'racesE/' , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data' ,
            Accept: "application/json",
}});
    return res.data;
}

export const addRace= async(nom,description) => {
    await axios.post(api+'races',{
        nom: nom,
        description: description
    }, {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data' ,
            Accept: "application/json",
}});
}



export const deleteRace = async (raceId) => {
    await axios.delete(api+'races/'+raceId , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
}});
}
